import { getDomain } from '@libs/utils';

export const MAPBOX_TOKEN = getDomain.isProduction
  ? import.meta.env.VITE_MAPBOX_PROD
  : import.meta.env.VITE_MAPBOX_DEV;
